import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, query, getDocs, addDoc, where, doc, updateDoc, getDoc } from '@firebase/firestore';

export const fetchCollection = async (collectionName) => {
    return await getDocs(collection(db, collectionName))
}

export const addTournamentToDb = async (tournamentObject) => {
    return await addDoc(collection(db, "tournaments"), tournamentObject)
}

export const addGolfCourseToDb = async (golfCourseObject) => {
    return await addDoc(collection(db, "golfCourses"), golfCourseObject)
}

export const addAssociationToDb = async (associationObject) => {
    return await addDoc(collection(db, "associations"), associationObject)
}

export const getTournamentById = async (tournamentId) => {
    const docRef = await getDoc(doc(db, "tournaments", tournamentId));
    if (!docRef.exists()) {
        console.error('No tournament found with ID:', tournamentId);
        return null; // No tournament found with the given ID
    }
    return docRef.data(); // Return the tournament data
}

export const updateTournamentInDb = async (tournamentId, updatedData) => {
    const tournamentRef = doc(db, 'tournaments', tournamentId);
    await updateDoc(tournamentRef, updatedData);
}

// utils.js
export async function fetchDocById(collection, id) {
    return await getDoc(doc(db, collection, id));
}

export async function updateGolfCourseInDb(id, data) {
    const golfCourseRef = doc(db, 'golfCourses', id);
    await updateDoc(golfCourseRef, data);
}